import SuggestedResultItem from "./SuggestedResultItem";
import NoResult from "./NoResult";
import styles from "./SuggestedResultList.module.scss";

export default function SuggestedResultList({ results, cegjelzo = false }) {
	if (cegjelzo) {
		return <div className={styles.suggestedList}>{results.length <= 0 ? <NoResult /> : results.filter((item) => !/felszámolás|végelszámolás|kényszertörlés|törlés|v. a./.test(item.name.toLowerCase())).map((item) => (item.id && item.address ? <SuggestedResultItem key={item.id} item={item} cegjelzo={cegjelzo} /> : null))}</div>;
	} else {
		return <div className={styles.suggestedList}>{results.length <= 0 ? <NoResult /> : results.filter((item) => !/felszámolás|végelszámolás|kényszertörlés|törlés|v. a./.test(item.Name.toLowerCase())).map((item) => (item.ShortTaxNumber ? <SuggestedResultItem key={item.ShortTaxNumber} item={item} /> : null))}</div>;
	}
}
